import styled from 'styled-components'

export const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1023px) {
    width: 100%;
  }
`
